import React from 'react'

import { Form, Col } from '_zari/core'

const CostoReposicionFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='COSTO REPOSICION' htmlFor='input-costoReposicion' xs={12} />
      <Col xs={12}>
        <Form.InputText defaultValue={iValue} disabled id='input-costoReposicion' name='costoReposicion' />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CostoReposicionFormGroup)
